import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { ButtonsBase } from 'page/catalog/ItemPreview/ButtonsBase'
import { SizingButton } from 'page/catalog/SizingButton/SizingButton'
import { opt } from 'store/opt'

export const Buttons = observer(() => {
  return <Vertical gap={8} wide>
    <ButtonsBase />
    {opt.sizing && <SizingButton />}
  </Vertical>
})
